import React from 'react';
import PropTypes from 'prop-types';

/**
 * Alert component to display pending non-AAS referees
 * Shows warning when there are active referees with blocked user accounts
 *
 * @param {Array} pendingReferees - Array of pending referee objects
 * @param {number} pendingCount - Count of pending referees
 */
const PendingRefereesAlert = ({ pendingReferees, pendingCount }) => {
  if (pendingCount === 0) {
    return null;
  }

  return (
    <div className="alert alert-warning mt-3 mb-0" role="alert">
      <strong>
        <i className="bi bi-exclamation-triangle me-2" />
        {pendingCount} Independent Assessor
        {pendingCount > 1 ? 's' : ''} Awaiting Activation
      </strong>
      <ul className="mb-0 mt-2">
        {pendingReferees.map((referee) => (
          <li key={referee.id}>
            {referee.attributes.label ||
              `${referee.attributes.name} ${referee.attributes.lastName}`}
          </li>
        ))}
      </ul>
      <small className="d-block mt-2">
        These users are blocked. Unblock them in admin referee administration to
        enable masquerading.
      </small>
    </div>
  );
};

PendingRefereesAlert.propTypes = {
  pendingReferees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      attributes: PropTypes.shape({
        label: PropTypes.string,
        name: PropTypes.string,
        lastName: PropTypes.string,
      }).isRequired,
    }),
  ).isRequired,
  pendingCount: PropTypes.number.isRequired,
};

export default PendingRefereesAlert;
